import { DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import { CURRENT_SEVERITY } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/CONSTANTS";
import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
import { clearMyIncidentStore } from "../../_pages/UserManagement/UserRegistration/helper";
let { Store } = configureStore();
export const createIncidentReport = async (data) => {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/create-incident-report",
      data
    );
    if (response.status) {
      let emptyData = { data: { data: [] } };
      Store.dispatch({
        type: USER_DATA_CONSTANT.INCIDENTS,
        data: emptyData,
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.MY_INCIDENTS,
        data: emptyData,
      });
    }
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const updateIncidentReport = async (data, id) => {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-incident-report/" + id,
      data
    );

    if (response.data.status);
    {
      clearMyIncidentStore();
      let emptyData = { data: { data: [] } };
      Store.dispatch({
        type: USER_DATA_CONSTANT.INCIDENTS,
        data: emptyData,
      });
    }
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const updateIncidentInvestigation = async (data, id) => {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/incident-investigation-report/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const updateIncidentReview = async (data, id) => {
  try {
    let emptyData = { data: { data: [] } };

    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-incident-review/" + id,
      data
    );
    if (response.data.status)
      Store.dispatch({
        type: USER_DATA_CONSTANT.INCIDENTS,
        data: emptyData,
      });
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const declineRow = async (id, data) => {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/send-back/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const updateIncidentClosure = async (data, id) => {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-incident-closure/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const deleteIncidentDetails = async (id) => {
  try {
    const response = await RestMethod.DELETE(
      "/global-configuration/ehs-module/delete-incident-details/" + id
    );
    if (response.status) clearMyIncidentStore();
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const getAllIncidents = async (filter) => {
  try {
    const myIncidentsData = Store.getState()?.userManagement?.incidents;

    if (
      Array.isArray(myIncidentsData?.incidentDetails) &&
      myIncidentsData?.incidentDetails?.length &&
      !filter
    ) {
      let incidentDetail = myIncidentsData?.incidentDetails;
      let roles = myIncidentsData?.roles;
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            status: 1,
            message: "Data from Store",
            data: {
              incidentDetails: incidentDetail?.map((row) => ({
                ...row,
                severity: CURRENT_SEVERITY(row),
                createdAtView: DDMMYYYYHHMMAFormat(row.createdAt),
                siteName: row?.site?.name,
                departmentName: row?.department?.name,
                areaName: row?.area?.name,
              })),
              roles,
            },
          });
        }, 0);
      });
    } else {
      let url = "/global-configuration/ehs-module/all-incident-details?";
      if (filter) url += filter;
      const response = await RestMethod.GET(url);
      const {
        status,
        message,
        data: { incidentDetails, roles },
      } = response.data;
      if (status && !filter)
        Store.dispatch({
          type: USER_DATA_CONSTANT.INCIDENTS,
          data: response,
        });
      return {
        status,
        message,
        data: {
          incidentDetails: incidentDetails?.map((row) => ({
            ...row,
            severity: CURRENT_SEVERITY(row),
            createdAtView: DDMMYYYYHHMMAFormat(row.createdAt),
            siteName: row?.site?.name,
            departmentName: row?.department?.name,
            areaName: row?.area?.name,
          })),
          roles,
        },
      };
    }
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const getAllIncidentHistory = async (filter) => {
  try {
    let url = "/global-configuration/ehs-module/login-user-approval-history?";

    if (filter) url += filter;

    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const getMyIncidents = async (filter) => {
  try {
    let url = "/global-configuration/ehs-module/my-incidents?";
    if (filter) url += filter;
    const myIncidentsData = Store.getState()?.userManagement?.myIncidents;

    if ((Array.isArray(myIncidentsData) && myIncidentsData.length === 0) || filter) {
      const response = await RestMethod.GET(url);
      if (!filter && response.data.status)
        Store.dispatch({
          type: USER_DATA_CONSTANT.MY_INCIDENTS,
          data: response,
        });
      return response.data;
    } else {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            status: 1,
            message: "Data from store",
            data: myIncidentsData,
          });
        }, 0);
      });
    }
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const getIncidentReportById = async (id, query) => {
  try {
    let url = "/global-configuration/ehs-module/incident-details/" + id;
    if (query) url += `?${query}`;

    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const addIncidentComment = async (data, id) => {
  try {
    let url = "/global-configuration/ehs-module/add-incident-comment/" + id;

    const response = await RestMethod.POST(url, data);
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const revertedInvestigation = async (id, data) => {
  try {
    let url = "/global-configuration/ehs-module/revert-investigation/" + id;
    let emptyData = { data: { data: [] } };
    const response = await RestMethod.PUT(url, data);
    if (response.data.status) {
      Store.dispatch({
        type: USER_DATA_CONSTANT.INCIDENTS,
        data: emptyData,
      });
    }
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const ltiHoursUpdate = async (data, id) => {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-lti-hours/" + id,
      data
    );
    if (response.status) {
      let emptyData = { data: { data: [] } };
      Store.dispatch({
        type: USER_DATA_CONSTANT.INCIDENTS,
        data: emptyData,
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.MY_INCIDENTS,
        data: emptyData,
      });
    }
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};
